var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90642 2.66929C8.96025 2.25957 7.7363 1.05021 7.32728 0.093619C7.2738 -0.0313799 7.09811 -0.0310327 7.04429 0.093619C6.63457 1.03979 5.42521 2.26374 4.46862 2.67276C4.34362 2.72624 4.34397 2.90193 4.46862 2.95575C5.41479 3.36547 6.63874 4.57483 7.04776 5.53142C7.10124 5.65642 7.27693 5.65607 7.33075 5.53142C7.74047 4.58525 8.94983 3.3613 9.90642 2.95228C10.0314 2.8988 10.0311 2.72311 9.90642 2.66929Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68769 5.84217C3.05679 5.56891 2.24082 4.76267 1.96826 4.12517C1.93249 4.04184 1.81548 4.04219 1.77937 4.12517C1.50611 4.75607 0.699864 5.57204 0.0623693 5.8446C-0.0209633 5.88037 -0.0206161 5.99738 0.0623693 6.03349C0.693267 6.30675 1.50923 7.113 1.7818 7.75049C1.81756 7.83382 1.93458 7.83348 1.97069 7.75049C2.24395 7.11959 3.05019 6.30363 3.68769 6.03106C3.77102 5.9953 3.77067 5.87828 3.68769 5.84217Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45843 8.68656C7.03794 8.50427 6.49385 7.96712 6.31226 7.54178C6.28864 7.48623 6.21052 7.48657 6.18656 7.54178C6.00427 7.96226 5.46712 8.50636 5.04178 8.68795C4.98623 8.71156 4.98657 8.78969 5.04178 8.81364C5.46226 8.99593 6.00636 9.53308 6.18795 9.95843C6.21156 10.014 6.28969 10.0136 6.31364 9.95843C6.49593 9.53794 7.03308 8.99385 7.45843 8.81226C7.51398 8.78864 7.51363 8.71052 7.45843 8.68656Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiBotIcon);
export default __webpack_public_path__ + "static/media/AIBotIcon.c3aa8298b5035d891c4b5a1262a8c118.svg";
export { ForwardRef as ReactComponent };